module.exports = __webpack_public_path__ + "revpar.png?fe1e8943d85cb41997070cc57a7d3710";